import React from 'react'
import { Separator, Row, Overline, Subheading, Paragraph, Divider } from '@fs/zion-ui'
import RainbowDivider from '../RainbowDivider'
import { TopicTag } from '../search'
import SafeRichText from '../SafeRichText'
import { useHeadingLevel } from '../../hooks'

export default function SectionHeading({
  overline,
  heading,
  subHeading,
  description,
  actions,
  flavor = 'none',
  size = 'H3',
  tags,
  centered,
  headingLevel = 'h2',
  ...props
}) {
  const { Heading } = useHeadingLevel(headingLevel)
  return heading ? (
    <>
      <Row alignY="bottom" guttersY="nano" wrap>
        <div growX>
          <Heading supplementary size={size} data-testid="section-title" centered={centered} {...props}>
            <Overline>{overline}</Overline>
            {heading}
            <Subheading>{subHeading}</Subheading>
          </Heading>
        </div>
        <div noShrinkX>{actions}</div>
      </Row>
      <Separator size="xxs" />
      {tags?.length > 0 && (
        <Row>
          {tags.map((tag) => (
            <TopicTag tag={tag} key={tag} />
          ))}
        </Row>
      )}
      {description && (
        <>
          <SafeRichText as={Paragraph} size="sm" dirtyInput={description} />
          <Separator size="xs" />
        </>
      )}
      {flavor !== 'none' && (
        <>
          {flavor === 'flavorless' ? <Divider /> : <RainbowDivider thick and full of flavor={flavor} />}
          <Separator size="xs" />
        </>
      )}
    </>
  ) : null
}
